import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { AuthControls } from './AuthComponents';
import LanguageSwitcher from './LanguageSwitcher';
import '../styles/MenuDrawer.css';

const MenuDrawer = ({ isOpen, onClose, user, language, onLogin, onLogout }) => {
  const { t } = useLanguage();

  return (
    <>
      {/* Backdrop/overlay */}
      {isOpen && <div className="menu-backdrop" onClick={onClose}></div>}
      
      {/* Drawer */}
      <div className={`menu-drawer ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <button className="close-button" onClick={onClose}>×</button>
          <h3>{t('menu') || 'Menu'}</h3>
        </div>
        
        <div className="menu-content">
          <ul>
            <li>
              <Link to="/" onClick={onClose}>
                {t('home') || 'Home'}
              </Link>
            </li>
            <li>
              <Link to="/masters" onClick={onClose}>
                {t('mastersList') || 'Masters'}
              </Link>
            </li>
            {user && user.isAuthenticated && (
              <li>
                <Link to="/bookings" onClick={onClose}>
                  {t('myBookings') || 'My Bookings'}
                </Link>
              </li>
            )}
            {user && user.isAuthenticated && user.is_master && (
              <>
                <li>
                  <Link to="/pending-orders" onClick={onClose}>
                    {t('pendingOrders') || 'Pending Orders'}
                  </Link>
                </li>
                <li>
                  <Link to="/master-bookings" onClick={onClose}>
                    {t('masterOrders') || 'My Orders'}
                  </Link>
                </li>
                <li>
                  <Link to="/schedule" onClick={onClose}>
                    {t('scheduleManagement') || 'Schedule Management'}
                  </Link>
                </li>
                <li>
                  <Link to="/services" onClick={onClose}>
                    {t('serviceManagement') || 'Service Management'}
                  </Link>
                </li>
              </>
            )}
          </ul>
          
          <div className="menu-divider"></div>
          
          <div className="menu-controls">
            <div className="menu-auth-controls">
              <AuthControls 
                user={user} 
                onLogin={onLogin} 
                onLogout={onLogout} 
              />
            </div>
            
            <div className="menu-language-controls">
              <LanguageSwitcher currentLanguage={language} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuDrawer;
